import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EyeAltIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EyeAltIcon = ({ className, ...props }: EyeAltIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 12.8889C7.2 5.77777 16.8 5.77777 20 12.8889"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M12 16.4444C10.5273 16.4444 9.33337 15.2505 9.33337 13.7778C9.33337 12.305 10.5273 11.1111 12 11.1111C13.4728 11.1111 14.6667 12.305 14.6667 13.7778C14.6667 15.2505 13.4728 16.4444 12 16.4444Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default EyeAltIcon;
